import { render, staticRenderFns } from "./FileUploadSaveAsTemp.vue?vue&type=template&id=327c1f00&"
import script from "./FileUploadSaveAsTemp.vue?vue&type=script&lang=js&"
export * from "./FileUploadSaveAsTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports